import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pb-8 md:pb-12 px-4 bg-white" data-id="element-88">
      <div className="bg-white border-b border-gray-100 py-3 md:py-4 mb-8 md:mb-10 text-center" data-id="element-89">
        <span className="text-lg md:text-xl font-black text-gray-900 tracking-wide" data-id="element-90">
          ✨ MI ESPACIO INTERIOR
        </span>
      </div>
      <div className="max-w-3xl mx-auto text-center" data-id="element-91">
        <h1 className="text-3xl md:text-5xl font-black text-gray-900 mb-4 md:mb-6 leading-tight" data-id="element-92">
          Todo lo que tu hijo necesita para su mundo emocional
        </h1>

        <button onClick={scrollToPricing} className="w-3/4 max-w-xs md:w-full md:max-w-lg mx-auto block cursor-pointer md:hover:scale-105 md:transition-transform md:duration-300" data-id="element-93">
          <img src="https://cdn.magicpatterns.com/uploads/rDk5fHbyA54YenggHYDYrS/mocap_espacio-removebg-preview.webp" alt="MegaPack Mi Espacio Interior" className="w-full h-auto md:drop-shadow-2xl mb-6 md:mb-8 rounded-xl" fetchPriority="high" decoding="auto" loading="eager" sizes="(max-width: 768px) 75vw, 512px" width={600} height={400} style={{
          aspectRatio: '3/2',
          objectFit: 'contain'
        }} data-id="element-94" />
        </button>

        <div className="bg-yellow-100 border-l-4 border-yellow-500 p-3 md:p-4 mb-6 md:mb-8 text-left md:text-center" data-id="element-95">
          <p className="text-base md:text-xl font-medium text-gray-800" data-id="element-96">
            El sistema N°1 de desarrollo emocional para adolescentes — 12 a 18
            años — Todos los niveles. Herramientas + ejercicios + guías listos
            para usar. Sin buscar. Sin improvisar. Sin perder más días sin saber
            cómo ayudar.
          </p>
        </div>

        <div className="max-w-md mx-auto" data-id="element-97">
          <CTAButton text="✨ QUIERO MI ESPACIO INTERIOR AHORA" subtext="📄 100% PDF • ⚡ Acceso inmediato • 🛡️ Garantía 7 días" size="sm" data-id="element-98" />
        </div>
      </div>
    </section>;
}